import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
// Multilingual support disabled - uncomment line below to re-enable
// import "./i18n/config";

// Render immediately for best LCP performance
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);